import type { TableData } from '../model/types'

import { map, pick, pipe, prop } from 'lodash/fp'

import {
	useAnchorsProductCatalogFiltersQuery,
	useAnchorsProductCatalogQuery,
} from '@/entities/anchor'
import { useSalesEntitiesQuery } from '@/entities/optimization-group'

export const useAnchorsProductCatalog = (
	products: Record<string, string[]>
) => {
	/*
	 * Queries
	 */
	const { data: salesEntities, isLoading: isSalesEntitiesLoading } =
		useSalesEntitiesQuery<{ id: string; name: string }[]>({
			select: pipe(prop('sales_entities'), map(pick(['id', 'name']))),
		})

	const {
		data: anchorsProductCatalogFilters,
		isLoading: isAnchorsProductCatalogFiltersLoading,
	} = useAnchorsProductCatalogFiltersQuery(products, {})

	const {
		data: tableProductsCatalog,
		isLoading: isTableProductsCatalogLoading,
	} = useAnchorsProductCatalogQuery<{
		data: TableData['anchors']
		total: number
	}>(
		{ filters: anchorsProductCatalogFilters },
		{
			enabled: !!anchorsProductCatalogFilters && !!salesEntities,
			select: (data) => ({
				data: data.data.map(
					({ sku, sales_entity_id, cost, last_price, title }) => ({
						title,
						sku,
						sales_entity: salesEntities!.find(
							(item) => item.id === sales_entity_id
						)!,
						cost,
						last_price,
						mul: null,
						add: null,
					})
				),
				total: data.total,
			}),
		}
	)

	const isLoading =
		isAnchorsProductCatalogFiltersLoading ||
		isTableProductsCatalogLoading ||
		isSalesEntitiesLoading

	return {
		isLoading,
		tableProductsCatalog: tableProductsCatalog?.data,
	}
}
